import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
  StyledDateContainer,
} from "../../common/StyledComponents/StyledFields";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import { ValidationError, object, string } from "yup";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";

const PoojaBooking = ({ sendDataToParent, getReportData }: any) => {
  /* Data that need to send to the parent */



  interface ErrorMessageTypes {
    signInName: string;
    donationDateFrom: string;
    donationDateTo: string;
  }

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    signInName: "",
    donationDateFrom:"",
    donationDateTo: "",
  });

  const [formData, setFormData] = useState({
    signInName: "",
    donationDateFrom: dayjs().subtract(7, 'day').format("MM-DD-YYYY"),
    donationDateTo: dayjs().format("MM-DD-YYYY"),
  });
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = object().shape({
    signInName: string().required("Sign-In Name is required"),
    // donationDateFrom: string().required("Donation Date From is required"),
    // donationDateTo: string().required("Donation Date To is required"),
  });

  const getPoojaBookingReportsBySignInName = () => {
    const reqBody = {
      signInName: formData.signInName,
      searchStartDate: formData.donationDateFrom,
      searchEndDate: formData.donationDateTo,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/pooja/POOJA_BOOKING_REPORT_BY_SIGN_IN_NAME/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, reqBody);
        const response = res?.data?.map((obj: any) => {
          return {
            Date: obj.datescheduled,
            Time: obj.totalhours,
            "Name of Priest": `${obj.firstname} ${obj.middlename} ${obj.lastname}`,
            "Type of Poojas Booked": obj.poojaname,
          };
        });
        getReportData(response);
      })

      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmit = async () => {
    const errors: ErrorMessageTypes = {
      signInName: "",
      donationDateFrom: "",
      donationDateTo: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      getPoojaBookingReportsBySignInName();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleClear = () => {
    setFormData({
      signInName: "",
      donationDateFrom: "",
      donationDateTo: "",
    });
  };

   // Search Devotee setters and handlers
   const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

   const handleOpenSearchDevoteeDialog = () => {
     setOpenSearchDevotee(true);
   }

   const handleClose = () => {
     setOpenSearchDevotee(false);
   }

   const hanldeSelectUser = (username: string) => {
     handleFieldChange(
       "signInName",
       username?.toUpperCase()
     );
     handleClose();
   } 

   
  const DatePickerFrom = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formData.donationDateFrom}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="donationDateFrom"
        format="MM-DD-YYYY"
        disableFuture     
      />
    );
  };

  const DatePickerTo = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formData.donationDateTo}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="donationDateTo"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };
 
  const handleFieldChange = (field: any, value: any) => {
    if (field === "donationDateFrom" || field === "donationDateTo") {
      const formattedDate = dayjs(value, "MM/DD/YYYY");

      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  return (
    <Box sx={{maxWidth: "450px"}}>
      <Grid container columnSpacing={"12px"} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Sign-In Name", true)}
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            required
            className={`text_field compact_fields bg_white ${errorMessage.signInName ? styles.errorTextField : styles.dateFeild}`}
            value={formData.signInName}
            onChange={(e) => {
              const inputValue = e.target.value;
              setErrorMessage({ ...errorMessage, signInName: "" });
              handleFieldChange("signInName", inputValue);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonSearch sx={{ml: "10px", cursor: "pointer", color: "#F05802"}} onClick={handleOpenSearchDevoteeDialog}/>
                </InputAdornment>
              ),
            }}
            sx={{
              backgroundColor: "white !important",
              "& .MuiOutlinedInput-root": {
                pr: "7px"
              }
            }}
          />

          {errorMessage.signInName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.signInName}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search by Donation Date From", false)}
          {DatePickerFrom()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search by Donation Date To", false)}
          {DatePickerTo()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmit}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
      {openSearchDevotee && <ReportsSearchDevotee open={openSearchDevotee} handleClose={handleClose} hanldeSelectUser={hanldeSelectUser}/>}
    </Box>
  );
};
export default PoojaBooking;
